module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Create Public Access Link","introduction":["Anyone with this Link will be able to fill out this Form in a web browser. Use the display name to remind yourself of where you posted it, who you shared it with, when it is intended to be active, and so on."],"field":{"once":"Single Submission"},"onceHelp":"Allow only one Submission from each browser."}}')
  delete Component.options._Ctor
}
